export enum FailureType {
  ACESSÓRIOS_E_OUTROS = "Acessórios e outros",
  ALINHAMENTO_DE_CHASSIDIREÇÃO = "Alinhamento de chassi/direção",
  AMORTECEDORES_SUSPENSÃO = "Amortecedores suspensão",
  ATRITO_DO_CHICOTE_ELÉTRICO_COM_O_CORRUGADO = "Atrito do chicote elétrico com o corrugado",
  ATUALIZAÇÃO_DE_SOFTWARE = "Atualização de software",
  AÇÃO_DE_CAMPO = "Ação de campo",
  BARRA_DE_DIREÇÃO = "Barra de direção",
  BATERIA = "Bateria",
  BOMBA_DÁGUA = "Bomba d'água",
  BOMBA_DE_ALTA_PRESSÃO_DE_COMBUSTIVEL = "Bomba de alta pressão de combustível",
  BOMBA_DE_ÓLEO = "Bomba de óleo",
  BOMBA_DIREÇÃO_HIDRÁULICA = "Bomba direção hidráulica",
  CABEÇOTE = "Cabeçote",
  CAIXA_DE_DIREÇÃO = "Caixa de direção",
  CAIXA_DE_MARCHAS_ENTRA_EM_NEUTRO = "Caixa de marchas - entra em neutro",
  CAIXA_DE_MUDANÇA = "Caixa de mudança",
  CAMISA_DO_BLOCO = "Camisa do bloco",
  CAPTAÇÃO_DE_AR_ENTRADA_DE_ABRASIVO = "Captação de ar / entrada de abrasivo",
  CARDAN = "Cardan",
  CARROCERIA = "Carroceria",
  CATALISADOR_OBSTRUÍDO = "Catalisador obstruído",
  CATRACA_DE_FREIO = "Catraca de freio",
  CHASSI = "Chassi",
  COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO = "Combustível, gás de escape e arrefecimento",
  COMPRESSOR_DE_AR = "Compressor de ar",
  CONSUMO_DE_OLEO_LUBRIFICANTE_EM_EXCESSO = "Consumo de óleo lubrificante em excesso",
  CUICA_DE_FREIO = "Cuíca de freio",
  CÂMARA_DE_FREIO = "Câmara de freio",
  DESGASTE_DE_ANEIS_SINCRONIZADORES = "Desgaste de anéis sincronizadores",
  DESGASTE_DE_LUVA_DE_ENGATE_GP_E_GV = "Desgaste de luva de engate GP e GV",
  DESGASTE_DO_GARFO_DE_ENGATE = "Desgaste do garfo de engate",
  EIXO_S_CAME = "Eixo 'S' came",
  EIXO_DE_TRAÇÃO = "Eixo de tração",
  EIXO_E_CAIXA_DE_DIREÇÃO = "Eixo e caixa de direção",
  EIXO_TRASEIRO = "Eixo traseiro",
  EM_DIAGNOSE_00_ACESSÓRIOS_E_OUTROS = "Em diagnose - 0.0 Acessórios e outros",
  EM_DIAGNOSE_10_MOTOR = "Em diagnose - 1.0 Motor",
  EM_DIAGNOSE_100_REVISÃO = "Em diagnose - 10.0 Revisão",
  EM_DIAGNOSE_110_SOFTWARE = "Em diagnose - 11.0 Software",
  EM_DIAGNOSE_120_SINISTRO = "Em diagnose - 12.0 Sinistro",
  EM_DIAGNOSE_130_AÇÃO_DE_CAMPO = "Em diagnose - 13.0 Ação de campo",
  EM_DIAGNOSE_20_COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO = "Em diagnose - 2.0 Combustível, gás de escape e arrefecimento (pós tratamento)",
  EM_DIAGNOSE_30_CAIXA_DE_MUDANÇA = "Em diagnose - 3.0 Caixa de mudança",
  EM_DIAGNOSE_40_EIXO_E_CAIXA_DE_DIREÇÃO = "Em diagnose - 4.0 Eixo e caixa de direção",
  EM_DIAGNOSE_50_EIXO_TRASEIRO = "Em diagnose - 5.0 Eixo traseiro",
  EM_DIAGNOSE_60_SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO = "Em diagnose - 6.0 Sistema de freio e circuito pneumático",
  EM_DIAGNOSE_70_SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA = "Em diagnose - 7.0 Sistema de alavanca (pedaleira e cabos de marcha)",
  EM_DIAGNOSE_80_CARROCERIA = "Em diagnose - 8.0 Carroceria",
  EM_DIAGNOSE_90_SISTEMA_ELÉTRICO = "Em diagnose - 9.0 Sistema elétrico",
  EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO = "Embreagem (incluindo sistema de acionamento)",
  EMBREAGEM_VISCOSA_HÉLICE = "Embreagem viscosa / hélice",
  EMBUCHAMENTO_MANGA_EIXO = "Embuchamento manga eixo",
  ENGATE_DE_MARCHAS = "Engate de marchas",
  FALTA_DE_LUBRIFICAÇÃO = "Falta de lubrificação",
  FREIO_MOTOR = "Freio motor",
  GELADEIRA = "Geladeira",
  INJETORES_DE_COMBUSTIVEL = "Injetores de combustível",
  LONA_DE_FREIO = "Lona de freio",
  MANGUEIRAS_TUBULAÇÕES = "Mangueiras / tubulações",
  MODIFICAÇÃOATUALIZAÇÃO_DE_PRODUTO = "Modificação/atualização de produto",
  MOLA_PNEUMÁTICA = "Mola pneumática",
  MOTOR = "Motor",
  MÓDULO_TCU = "Módulo TCU",
  OUTROS_10_MOTOR = "Outros - 1.0 Motor",
  OUTROS_100_REVISÃO = "Outros - 10.0 Revisão",
  OUTROS_110_SOFTWARE = "Outros - 11.0 Software",
  OUTROS_120_SINISTRO = "Outros - 12.0 Sinistro",
  OUTROS_130_AÇÃO_DE_CAMPO = "Outros - 13.0 Ação de campo",
  OUTROS_20_COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO = "Outros - 2.0 Combustível, gás de escape e arrefecimento (pós tratamento)",
  OUTROS_30_CAIXA_DE_MUDANÇA = "Outros - 3.0 Caixa de mudança",
  OUTROS_40_EIXO_E_CAIXA_DE_DIREÇÃO = "Outros - 4.0 Eixo e caixa de direção",
  OUTROS_50_EIXO_TRASEIRO = "Outros - 5.0 Eixo traseiro",
  OUTROS_60_SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO = "Outros - 6.0 Sistema de freio e circuito pneumático",
  OUTROS_70_SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA = "Outros - 7.0 Sistema de alavanca (pedaleira e cabos de marcha)",
  OUTROS_80_CARROCERIA = "Outros - 8.0 Carroceria",
  OUTROS_90_SISTEMA_ELÉTRICO = "Outros - 9.0 Sistema elétrico",
  OUTROS_ACESSÓRIOS_E_OUTROS = "Outros - Acessórios e outros",
  PERDA_DE_POTÊNCIA = "Perda de potência",
  PINTURA_C_PROBLEMA_QUALIDADE = "Pintura c problema qualidade",
  PRESSÃO_LÍQ_ARREFECIMENTO_DO_MOTOR = "Pressão líq. arrefecimento do motor",
  PÓS_TRATAMENTO = "Pós-tratamento",
  QUEBRA_DA_ABRAÇADEIRA_TUBO_DE_ESCAPE_PÓS_TURBO = "Quebra da abraçadeira tubo de escape pós turbo",
  QUEBRA_DO_SUPORTE_DO_PARALAMA = "Quebra do suporte do paralama",
  RADIADOR = "Radiador",
  RASTREADOR = "Rastreador",
  REFORMA_ENTRE_SAFRA = "Reforma entre safra",
  REPARO = "Reparo",
  REPARO_DE_FUNILARIA_E_PINTURA = "Reparo de funilaria e pintura",
  RETENTORCUBOROLAMENTO = "Retentor/cubo/rolamento",
  RETRABALHO_CHASSI = "Retrabalho chassi",
  REVISÃO = "Revisão",
  REVISÃO_ACESSÓRIOS_E_OUTROS = "Revisão - Acessórios e outros",
  REVISÃO_VEICULO_DEMONSTRAÇÃO = "Revisão veiculo demonstração",
  ROLAMENTO_DE_RODA = "Rolamento de roda",
  ROTAÇÃO_DE_BRONZINACASQUILHO = "Rotação de bronzina/casquilho",
  SINISTRO = "Sinistro",
  SISTEMA_ABS = "Sistema ABS",
  SISTEMA_DE_ADMISSÃO_DE_AR = "Sistema de admissão de ar",
  SISTEMA_DE_ALIMENTAÇÂO_DE_COMBUSTIVEL = "Sistema de alimentação de combustível",
  SISTEMA_DE_ELEVAÇÃO_DE_EIXO = "Sistema de elevação de eixo",
  SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO = "Sistema de freio e circuito pneumático",
  SISTEMA_ELÉTRICO = "Sistema elétrico",
  SISTEMAMANGUEIRAS_DE_ARREFECIMENTO = "Sistema/mangueiras de arrefecimento",
  SOFTWARE = "Software",
  TIRANTE_V = "Tirante V",
  TROCA_RELAÇÃO_DIFERENCIAL = "Troca relação diferencial",
  TUBO_DE_ADMISSÃO_DE_AR_COM_CORROSÃO = "Tubo de admissão de ar com corrosão",
  TUBOS_SISTEMA_DE_ESCAPAMENTO = "Tubos sistema de escapamento",
  TURBOCOMPRESSOR = "Turbocompressor",
  VAZAMENTO_DE_LUBRIFICANTE_PELA_PTO = "Vazamento de lubrificante pela PTO",
  VAZAMENTO_DE_ÓLEO_LUBRIFICANTE = "Vazamento de óleo lubrificante",
  SISTEMA_DE_AR_CONDICIONADO = "Sistema de ar condicionado",
  DIAGNOSE_INDEFINIDA = "Diagnose Indefinida"
}

export enum FailureMode {
  ACESSÓRIOS_E_OUTROS = "0.0 Acessórios e outros",
  MOTOR = "1.0 Motor",
  EMBREAGEM_EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO = "1.1 Embreagem (embreagem, incluindo sistema de acionamento)",
  REVISÃO = "10.0 Revisão",
  SOFTWARE = "11.0 Software",
  SINISTRO = "12.0 Sinistro",
  AÇÃO_DE_CAMPO = "13.0 Ação de campo",
  COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO = "2.0 Combustível, gás de escape e arrefecimento (pós tratamento)",
  PÓSTRATAMENTO = "2.1 Pós-tratamento",
  CAIXA_DE_MUDANÇA = "3.0 Caixa de mudança",
  EIXO_E_CAIXA_DE_DIREÇÃO = "4.0 Eixo e caixa de direção",
  SISTEMA_DE_SUSPENSÃO_DIANTEIRA = "4.1 Sistema de suspensão dianteira",
  SISTEMA_DE_DIREÇÃO = "4.2 Sistema de direção",
  EIXO_TRASEIRO = "5.0 Eixo traseiro",
  ROLAMENTO_DE_RODA = "5.1 Rolamento de roda",
  SISTEMA_DE_SUSPENSÃO_TRASEIRA = "5.2 Sistema de suspensão traseira",
  SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO = "6.0 Sistema de freio e circuito pneumático",
  SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA = "7.0 Sistema de alavanca (pedaleira e cabos de marcha)",
  CARROCERIA = "8.0 Carroceria",
  CHASSI = "8.1 Chassi",
  SISTEMA_ELÉTRICO = "9.0 Sistema elétrico",
  AR_CONDICIONADO = "Ar condicionado",
  DIAGNOSE_NÃO_REALIZADA = "Diagnose não realizada"
}

export const FailureTypeLabelIdMap: Record<FailureType, string> = {
  [FailureType.ACESSÓRIOS_E_OUTROS]: "intl-msg:shared.occurrence.failureType.acessoriosEOutros",
  [FailureType.ALINHAMENTO_DE_CHASSIDIREÇÃO]: "intl-msg:shared.occurrence.failureType.alinhamentoDeChassidirecao",
  [FailureType.AMORTECEDORES_SUSPENSÃO]: "intl-msg:shared.occurrence.failureType.amortecedoresSuspensao",
  [FailureType.ATRITO_DO_CHICOTE_ELÉTRICO_COM_O_CORRUGADO]: "intl-msg:shared.occurrence.failureType.atritoDoChicoteEletricoComOCorrugado",
  [FailureType.ATUALIZAÇÃO_DE_SOFTWARE]: "intl-msg:shared.occurrence.failureType.atualizacaoDeSoftware",
  [FailureType.AÇÃO_DE_CAMPO]: "intl-msg:shared.occurrence.failureType.acaoDeCampo",
  [FailureType.BARRA_DE_DIREÇÃO]: "intl-msg:shared.occurrence.failureType.barraDeDirecao",
  [FailureType.BATERIA]: "intl-msg:shared.occurrence.failureType.bateria",
  [FailureType.BOMBA_DÁGUA]: "intl-msg:shared.occurrence.failureType.bombaDagua",
  [FailureType.BOMBA_DE_ALTA_PRESSÃO_DE_COMBUSTIVEL]: "intl-msg:shared.occurrence.failureType.bombaDeAltaPressaoDeCombustivel",
  [FailureType.BOMBA_DE_ÓLEO]: "intl-msg:shared.occurrence.failureType.bombaDeOleo",
  [FailureType.BOMBA_DIREÇÃO_HIDRÁULICA]: "intl-msg:shared.occurrence.failureType.bombaDirecaoHidraulica",
  [FailureType.CABEÇOTE]: "intl-msg:shared.occurrence.failureType.cabecote",
  [FailureType.CAIXA_DE_DIREÇÃO]: "intl-msg:shared.occurrence.failureType.caixaDeDirecao",
  [FailureType.CAIXA_DE_MARCHAS_ENTRA_EM_NEUTRO]: "intl-msg:shared.occurrence.failureType.caixaDeMarchasEntraEmNeutro",
  [FailureType.CAIXA_DE_MUDANÇA]: "intl-msg:shared.occurrence.failureType.caixaDeMudanca",
  [FailureType.CAMISA_DO_BLOCO]: "intl-msg:shared.occurrence.failureType.camisaDoBloco",
  [FailureType.CAPTAÇÃO_DE_AR_ENTRADA_DE_ABRASIVO]: "intl-msg:shared.occurrence.failureType.captacaoDeArEntradaDeAbrasivo",
  [FailureType.CARDAN]: "intl-msg:shared.occurrence.failureType.cardan",
  [FailureType.CARROCERIA]: "intl-msg:shared.occurrence.failureType.carroceria",
  [FailureType.CATALISADOR_OBSTRUÍDO]: "intl-msg:shared.occurrence.failureType.catalisadorObstruido",
  [FailureType.CATRACA_DE_FREIO]: "intl-msg:shared.occurrence.failureType.catracaDeFreio",
  [FailureType.CHASSI]: "intl-msg:shared.occurrence.failureType.chassi",
  [FailureType.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO]: "intl-msg:shared.occurrence.failureType.combustivelGasDeEscapeEArrefecimento",
  [FailureType.COMPRESSOR_DE_AR]: "intl-msg:shared.occurrence.failureType.compressorDeAr",
  [FailureType.CONSUMO_DE_OLEO_LUBRIFICANTE_EM_EXCESSO]: "intl-msg:shared.occurrence.failureType.consumoDeOleoLubrificanteEmExcesso",
  [FailureType.CUICA_DE_FREIO]: "intl-msg:shared.occurrence.failureType.cuicaDeFreio",
  [FailureType.CÂMARA_DE_FREIO]: "intl-msg:shared.occurrence.failureType.camaraDeFreio",
  [FailureType.DESGASTE_DE_ANEIS_SINCRONIZADORES]: "intl-msg:shared.occurrence.failureType.desgasteDeAneisSincronizadores",
  [FailureType.DESGASTE_DE_LUVA_DE_ENGATE_GP_E_GV]: "intl-msg:shared.occurrence.failureType.desgasteDeLuvaDeEngateGpEGv",
  [FailureType.DESGASTE_DO_GARFO_DE_ENGATE]: "intl-msg:shared.occurrence.failureType.desgasteDoGarfoDeEngate",
  [FailureType.EIXO_S_CAME]: "intl-msg:shared.occurrence.failureType.eixoSCame",
  [FailureType.EIXO_DE_TRAÇÃO]: "intl-msg:shared.occurrence.failureType.eixoDeTracao",
  [FailureType.EIXO_E_CAIXA_DE_DIREÇÃO]: "intl-msg:shared.occurrence.failureType.eixoECaixaDeDirecao",
  [FailureType.EIXO_TRASEIRO]: "intl-msg:shared.occurrence.failureType.eixoTraseiro",
  [FailureType.EM_DIAGNOSE_00_ACESSÓRIOS_E_OUTROS]: "intl-msg:shared.occurrence.failureType.emDiagnose00AcessoriosEOutros",
  [FailureType.EM_DIAGNOSE_10_MOTOR]: "intl-msg:shared.occurrence.failureType.emDiagnose10Motor",
  [FailureType.EM_DIAGNOSE_100_REVISÃO]: "intl-msg:shared.occurrence.failureType.emDiagnose100Revisao",
  [FailureType.EM_DIAGNOSE_110_SOFTWARE]: "intl-msg:shared.occurrence.failureType.emDiagnose110Software",
  [FailureType.EM_DIAGNOSE_120_SINISTRO]: "intl-msg:shared.occurrence.failureType.emDiagnose120Sinistro",
  [FailureType.EM_DIAGNOSE_130_AÇÃO_DE_CAMPO]: "intl-msg:shared.occurrence.failureType.emDiagnose130AcaoDeCampo",
  [FailureType.EM_DIAGNOSE_20_COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO]: "intl-msg:shared.occurrence.failureType.emDiagnose20CombustivelGasDeEscapeEArrefecimentoPosTratamento",
  [FailureType.EM_DIAGNOSE_30_CAIXA_DE_MUDANÇA]: "intl-msg:shared.occurrence.failureType.emDiagnose30CaixaDeMudanca",
  [FailureType.EM_DIAGNOSE_40_EIXO_E_CAIXA_DE_DIREÇÃO]: "intl-msg:shared.occurrence.failureType.emDiagnose40EixoECaixaDeDirecao",
  [FailureType.EM_DIAGNOSE_50_EIXO_TRASEIRO]: "intl-msg:shared.occurrence.failureType.emDiagnose50EixoTraseiro",
  [FailureType.EM_DIAGNOSE_60_SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO]: "intl-msg:shared.occurrence.failureType.emDiagnose60SistemaDeFreioECircuitoPneumatico",
  [FailureType.EM_DIAGNOSE_70_SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA]: "intl-msg:shared.occurrence.failureType.emDiagnose70SistemaDeAlavancaPedaleiraECabosDeMarcha",
  [FailureType.EM_DIAGNOSE_80_CARROCERIA]: "intl-msg:shared.occurrence.failureType.emDiagnose80Carroceria",
  [FailureType.EM_DIAGNOSE_90_SISTEMA_ELÉTRICO]: "intl-msg:shared.occurrence.failureType.emDiagnose90SistemaEletrico",
  [FailureType.EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO]: "intl-msg:shared.occurrence.failureType.embreagemIncluindoSistemaDeAcionamento",
  [FailureType.EMBREAGEM_VISCOSA_HÉLICE]: "intl-msg:shared.occurrence.failureType.embreagemViscosaHelice",
  [FailureType.EMBUCHAMENTO_MANGA_EIXO]: "intl-msg:shared.occurrence.failureType.embuchamentoMangaEixo",
  [FailureType.ENGATE_DE_MARCHAS]: "intl-msg:shared.occurrence.failureType.engateDeMarchas",
  [FailureType.FALTA_DE_LUBRIFICAÇÃO]: "intl-msg:shared.occurrence.failureType.faltaDeLubrificacao",
  [FailureType.FREIO_MOTOR]: "intl-msg:shared.occurrence.failureType.freioMotor",
  [FailureType.GELADEIRA]: "intl-msg:shared.occurrence.failureType.geladeira",
  [FailureType.INJETORES_DE_COMBUSTIVEL]: "intl-msg:shared.occurrence.failureType.injetoresDeCombustivel",
  [FailureType.LONA_DE_FREIO]: "intl-msg:shared.occurrence.failureType.lonaDeFreio",
  [FailureType.MANGUEIRAS_TUBULAÇÕES]: "intl-msg:shared.occurrence.failureType.mangueirasTubulacoes",
  [FailureType.MODIFICAÇÃOATUALIZAÇÃO_DE_PRODUTO]: "intl-msg:shared.occurrence.failureType.modificacaoatualizacaoDeProduto",
  [FailureType.MOLA_PNEUMÁTICA]: "intl-msg:shared.occurrence.failureType.molaPneumatica",
  [FailureType.MOTOR]: "intl-msg:shared.occurrence.failureType.motor",
  [FailureType.MÓDULO_TCU]: "intl-msg:shared.occurrence.failureType.moduloTcu",
  [FailureType.OUTROS_10_MOTOR]: "intl-msg:shared.occurrence.failureType.outros10Motor",
  [FailureType.OUTROS_100_REVISÃO]: "intl-msg:shared.occurrence.failureType.outros100Revisao",
  [FailureType.OUTROS_110_SOFTWARE]: "intl-msg:shared.occurrence.failureType.outros110Software",
  [FailureType.OUTROS_120_SINISTRO]: "intl-msg:shared.occurrence.failureType.outros120Sinistro",
  [FailureType.OUTROS_130_AÇÃO_DE_CAMPO]: "intl-msg:shared.occurrence.failureType.outros130AcaoDeCampo",
  [FailureType.OUTROS_20_COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO]: "intl-msg:shared.occurrence.failureType.outros20CombustivelGasDeEscapeEArrefecimentoPosTratamento",
  [FailureType.OUTROS_30_CAIXA_DE_MUDANÇA]: "intl-msg:shared.occurrence.failureType.outros30CaixaDeMudanca",
  [FailureType.OUTROS_40_EIXO_E_CAIXA_DE_DIREÇÃO]: "intl-msg:shared.occurrence.failureType.outros40EixoECaixaDeDirecao",
  [FailureType.OUTROS_50_EIXO_TRASEIRO]: "intl-msg:shared.occurrence.failureType.outros50EixoTraseiro",
  [FailureType.OUTROS_60_SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO]: "intl-msg:shared.occurrence.failureType.outros60SistemaDeFreioECircuitoPneumatico",
  [FailureType.OUTROS_70_SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA]: "intl-msg:shared.occurrence.failureType.outros70SistemaDeAlavancaPedaleiraECabosDeMarcha",
  [FailureType.OUTROS_80_CARROCERIA]: "intl-msg:shared.occurrence.failureType.outros80Carroceria",
  [FailureType.OUTROS_90_SISTEMA_ELÉTRICO]: "intl-msg:shared.occurrence.failureType.outros90SistemaEletrico",
  [FailureType.OUTROS_ACESSÓRIOS_E_OUTROS]: "intl-msg:shared.occurrence.failureType.outrosAcessoriosEOutros",
  [FailureType.PERDA_DE_POTÊNCIA]: "intl-msg:shared.occurrence.failureType.perdaDePotencia",
  [FailureType.PINTURA_C_PROBLEMA_QUALIDADE]: "intl-msg:shared.occurrence.failureType.pinturaCProblemaQualidade",
  [FailureType.PRESSÃO_LÍQ_ARREFECIMENTO_DO_MOTOR]: "intl-msg:shared.occurrence.failureType.pressaoLiqArrefecimentoDoMotor",
  [FailureType.PÓS_TRATAMENTO]: "intl-msg:shared.occurrence.failureType.posTratamento",
  [FailureType.QUEBRA_DA_ABRAÇADEIRA_TUBO_DE_ESCAPE_PÓS_TURBO]: "intl-msg:shared.occurrence.failureType.quebraDaAbracadeiraTuboDeEscapePosTurbo",
  [FailureType.QUEBRA_DO_SUPORTE_DO_PARALAMA]: "intl-msg:shared.occurrence.failureType.quebraDoSuporteDoParalama",
  [FailureType.RADIADOR]: "intl-msg:shared.occurrence.failureType.radiador",
  [FailureType.RASTREADOR]: "intl-msg:shared.occurrence.failureType.rastreador",
  [FailureType.REFORMA_ENTRE_SAFRA]: "intl-msg:shared.occurrence.failureType.reformaEntreSafra",
  [FailureType.REPARO]: "intl-msg:shared.occurrence.failureType.reparo",
  [FailureType.REPARO_DE_FUNILARIA_E_PINTURA]: "intl-msg:shared.occurrence.failureType.reparoDeFunilariaEPintura",
  [FailureType.RETENTORCUBOROLAMENTO]: "intl-msg:shared.occurrence.failureType.retentorcuborolamento",
  [FailureType.RETRABALHO_CHASSI]: "intl-msg:shared.occurrence.failureType.retrabalhoChassi",
  [FailureType.REVISÃO]: "intl-msg:shared.occurrence.failureType.revisao",
  [FailureType.REVISÃO_ACESSÓRIOS_E_OUTROS]: "intl-msg:shared.occurrence.failureType.revisaoAcessoriosEOutros",
  [FailureType.REVISÃO_VEICULO_DEMONSTRAÇÃO]: "intl-msg:shared.occurrence.failureType.revisaoVeiculoDemonstracao",
  [FailureType.ROLAMENTO_DE_RODA]: "intl-msg:shared.occurrence.failureType.rolamentoDeRoda",
  [FailureType.ROTAÇÃO_DE_BRONZINACASQUILHO]: "intl-msg:shared.occurrence.failureType.rotacaoDeBronzinacasquilho",
  [FailureType.SINISTRO]: "intl-msg:shared.occurrence.failureType.sinistro",
  [FailureType.SISTEMA_ABS]: "intl-msg:shared.occurrence.failureType.sistemaAbs",
  [FailureType.SISTEMA_DE_ADMISSÃO_DE_AR]: "intl-msg:shared.occurrence.failureType.sistemaDeAdmissaoDeAr",
  [FailureType.SISTEMA_DE_ALIMENTAÇÂO_DE_COMBUSTIVEL]: "intl-msg:shared.occurrence.failureType.sistemaDeAlimentacaoDeCombustivel",
  [FailureType.SISTEMA_DE_ELEVAÇÃO_DE_EIXO]: "intl-msg:shared.occurrence.failureType.sistemaDeElevacaoDeEixo",
  [FailureType.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO]: "intl-msg:shared.occurrence.failureType.sistemaDeFreioECircuitoPneumatico",
  [FailureType.SISTEMA_ELÉTRICO]: "intl-msg:shared.occurrence.failureType.sistemaEletrico",
  [FailureType.SISTEMAMANGUEIRAS_DE_ARREFECIMENTO]: "intl-msg:shared.occurrence.failureType.sistemamangueirasDeArrefecimento",
  [FailureType.SOFTWARE]: "intl-msg:shared.occurrence.failureType.software",
  [FailureType.TIRANTE_V]: "intl-msg:shared.occurrence.failureType.tiranteV",
  [FailureType.TROCA_RELAÇÃO_DIFERENCIAL]: "intl-msg:shared.occurrence.failureType.trocaRelacaoDiferencial",
  [FailureType.TUBO_DE_ADMISSÃO_DE_AR_COM_CORROSÃO]: "intl-msg:shared.occurrence.failureType.tuboDeAdmissaoDeArComCorrosao",
  [FailureType.TUBOS_SISTEMA_DE_ESCAPAMENTO]: "intl-msg:shared.occurrence.failureType.tubosSistemaDeEscapamento",
  [FailureType.TURBOCOMPRESSOR]: "intl-msg:shared.occurrence.failureType.turbocompressor",
  [FailureType.VAZAMENTO_DE_LUBRIFICANTE_PELA_PTO]: "intl-msg:shared.occurrence.failureType.vazamentoDeLubrificantePelaPto",
  [FailureType.VAZAMENTO_DE_ÓLEO_LUBRIFICANTE]: "intl-msg:shared.occurrence.failureType.vazamentoDeOleoLubrificante",
  [FailureType.SISTEMA_DE_AR_CONDICIONADO]: "intl-msg:shared.occurrence.failureType.sistemaDeArCondicionado",
  [FailureType.DIAGNOSE_INDEFINIDA]: "intl-msg:shared.occurrence.failureType.diagnoseIndefinida",
};

export const FailureModeLabelIdMap: Record<FailureMode, string> = {
  [FailureMode.ACESSÓRIOS_E_OUTROS]: "intl-msg:shared.occurrence.failureMode.acessoriosEOutros",
  [FailureMode.MOTOR]: "intl-msg:shared.occurrence.failureMode.motor",
  [FailureMode.EMBREAGEM_EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO]: "intl-msg:shared.occurrence.failureMode.embreagemEmbreagemIncluindoSistemaDeAcionamento",
  [FailureMode.REVISÃO]: "intl-msg:shared.occurrence.failureMode.revisao",
  [FailureMode.SOFTWARE]: "intl-msg:shared.occurrence.failureMode.software",
  [FailureMode.SINISTRO]: "intl-msg:shared.occurrence.failureMode.sinistro",
  [FailureMode.AÇÃO_DE_CAMPO]: "intl-msg:shared.occurrence.failureMode.acaoDeCampo",
  [FailureMode.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO]: "intl-msg:shared.occurrence.failureMode.combustivelGasDeEscapeEArrefecimentoPosTratamento",
  [FailureMode.PÓSTRATAMENTO]: "intl-msg:shared.occurrence.failureMode.postratamento",
  [FailureMode.CAIXA_DE_MUDANÇA]: "intl-msg:shared.occurrence.failureMode.caixaDeMudanca",
  [FailureMode.EIXO_E_CAIXA_DE_DIREÇÃO]: "intl-msg:shared.occurrence.failureMode.eixoECaixaDeDirecao",
  [FailureMode.SISTEMA_DE_SUSPENSÃO_DIANTEIRA]: "intl-msg:shared.occurrence.failureMode.sistemaDeSuspensaoDianteira",
  [FailureMode.SISTEMA_DE_DIREÇÃO]: "intl-msg:shared.occurrence.failureMode.sistemaDeDirecao",
  [FailureMode.EIXO_TRASEIRO]: "intl-msg:shared.occurrence.failureMode.eixoTraseiro",
  [FailureMode.ROLAMENTO_DE_RODA]: "intl-msg:shared.occurrence.failureMode.rolamentoDeRoda",
  [FailureMode.SISTEMA_DE_SUSPENSÃO_TRASEIRA]: "intl-msg:shared.occurrence.failureMode.sistemaDeSuspensaoTraseira",
  [FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO]: "intl-msg:shared.occurrence.failureMode.sistemaDeFreioECircuitoPneumatico",
  [FailureMode.SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA]: "intl-msg:shared.occurrence.failureMode.sistemaDeAlavancaPedaleiraECabosDeMarcha",
  [FailureMode.CARROCERIA]: "intl-msg:shared.occurrence.failureMode.carroceria",
  [FailureMode.CHASSI]: "intl-msg:shared.occurrence.failureMode.chassi",
  [FailureMode.SISTEMA_ELÉTRICO]: "intl-msg:shared.occurrence.failureMode.sistemaEletrico",
  [FailureMode.AR_CONDICIONADO]: "intl-msg:shared.occurrence.failureMode.arCondicionado",
  [FailureMode.DIAGNOSE_NÃO_REALIZADA]: "intl-msg:shared.occurrence.failureMode.diagnoseNaoRealizada",
};

export const getFailureTypeLabelId = (failureType?: string | null): string | undefined =>
  failureType ? FailureTypeLabelIdMap[failureType as FailureType] : undefined;

export const getFailureModeLabelId = (failureMode?: string | null): string | undefined =>
  failureMode ? FailureModeLabelIdMap[failureMode as FailureMode] : undefined;
